import type { ReactNode } from "react";
import type { DatasetUsage } from "@/lib/api/datasets";

export const fadeOutClass = (isFading: boolean) =>
  isFading
    ? "opacity-0 max-h-0 overflow-hidden transition-all duration-500 ease-out pointer-events-none"
    : "max-h-96 transition-all duration-500 ease-out";

export interface TransferTable {
  id: string;
  name: string;
  subtitle?: ReactNode;
  /** Links connecting this table to tables in other models. These break when
   * the table is deleted. `0`/undefined → no external-link indicator. */
  externalLinkCount?: number;
  datasetUsage?: DatasetUsage;
  /** Who imports it, once it has left its risk section. */
  risk?: TableSeverityConfig;
}

export interface TableSeverityConfig {
  color: string;
  tooltip: string;
}

export interface TableSectionConfig {
  key: string;
  title: string;
  severity: TableSeverityConfig;
}
